import axios from "axios";
import { backendURL } from "../url";

const API_URL = `${backendURL}/api/membership`;

export const getMembershipListing = async () => {
  try {
    const response = await axios.get(`${API_URL}/membership-listings`);
    return response.data.membershipListing;
  } catch (error) {
    console.error("Error fetching membership listing:", error);
    throw error;
  }
};

export const createMembershipListing = async (data: FormData) => {
  try {
    const response = await axios.post(
      `${API_URL}/create-membership-listing`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating membership listing:", error);
    throw error;
  }
};

export const deleteMembershipListing = async (id: string) => {
  try {
    const response = await axios.delete(
      `${API_URL}/delete-membership-listing/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting membership listing:", error);
    throw error;
  }
};

export const updateMembershipListing = async (id: string, data: FormData) => {
  try {
    const response = await axios.put(
      `${API_URL}/update-membership-listing/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating membership listing:", error);
    throw error;
  }
};

export const createMembership = async (data: any) => {
  try {
    const response = await axios.post(`${API_URL}/create-membership`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating membership:", error);
    throw error
  }
};

export const getMembershipById = async (id: string) => {
  try {
    const response = await axios.post(`${API_URL}/get-membership`, { id }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    })
    return response.data;
  } catch (error) {
    console.error("Error fetching membership by ID:", error);
    throw error;    
  }
}

export const getMembershipsAdmin = async () => {
  try {
    const response = await axios.get(`${API_URL}/retrieve-memberships`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    })
    return response.data.memberships;
  } catch (error) {
    console.error("Error fetching memberships:", error);
    throw error;
  }
}

export const cancelMembership = async (membershipId: string, stripeSubscriptionId: string) => {
  try {
    const response = await axios.post(
      `${API_URL}/cancel-membership`,
      { membershipId, stripeSubscriptionId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error cancelling membership:", error);
    throw error;
  }
}

export const pauseMembership = async (membershipId: string, subscriptionId: string) => {
  try {
    const response = await axios.post(
      `${API_URL}/pause-membership`,
      { membershipId, subscriptionId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error pausing membership:", error);
    throw error;
  }
}

export const resumeMembership = async (membershipId: string, subscriptionId: string) => {
  try {
    const response = await axios.post(
      `${API_URL}/resume-membership`,
      { membershipId, subscriptionId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error pausing membership:", error);
    throw error;
  }
}

export const createAdminMembership = async (data: Record<string, any>) => {
  try {
    const response = await axios.post(
      `${API_URL}/admin-membership`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating admin membership:", error);
    throw error;
  } 
}

export const updateAdminMembership = async (id: string, newStatus: any) => {
  try {
    const statusPayload = typeof newStatus === 'string' ? { status: newStatus } : newStatus;
    const response = await axios.post(
      `${API_URL}/update-admin-membership`,
        { data: { id, ...statusPayload } },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating admin membership:", error);
    throw error;
  }
}